import React, { useState } from 'react';
import { Send, CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { subscribeContent } from '../../data/mock';

const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    
    setTimeout(() => {
      setStatus('success');
      window.location.href = `mailto:hello@summarygpt.com?subject=Early%20Access%20Request&body=Please%20add%20me%20to%20the%20early%20access%20list.%20My%20email%20is:%20${encodeURIComponent(email)}`;
    }, 1000);
  };

  if (status === 'success') {
    return (
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-500/10 border border-emerald-500/25 mb-6">
          <CheckCircle className="w-8 h-8 text-emerald-400" />
        </div>
        <h3 className="text-2xl font-bold text-white mb-3">You're in.</h3>
        <p className="text-slate-400">We'll reach out when something new is ready.</p>
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
        {subscribeContent.headline}
      </h2>
      <p className="text-lg text-slate-400 mb-10">
        {subscribeContent.description}
      </p>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
        <Input
          type="email"
          placeholder={subscribeContent.placeholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="flex-1 h-14 px-5 bg-slate-900/60 border-slate-700/80 text-white placeholder:text-slate-500 focus:border-amber-500/50 focus:ring-amber-500/20 rounded-xl text-base"
        />
        <Button
          type="submit"
          disabled={status === 'loading'}
          className="h-14 px-8 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-slate-900 font-semibold shadow-lg shadow-amber-500/25 hover:shadow-amber-500/35 transition-all duration-300 border-0 gap-2 disabled:opacity-50 rounded-xl"
        >
          {status === 'loading' ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <>
              {subscribeContent.buttonText}
              <Send className="w-4 h-4" />
            </>
          )}
        </Button>
      </form>
    </div>
  );
};

export default SubscribeForm;
